import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const InfoSquareFilledIcon = forwardRef(function InfoSquareFilledIcon(props, ref) {
    return (_jsx("svg", { ref: ref, width: "1rem", height: "1rem", viewBox: "0 0 16 16", fill: "currentColor", ...props, children: _jsx("path", { fillRule: "evenodd", d: "M1 1h14v14H1V1Zm7.75 5H6.5v1.5h.75V11H6v1.5h4V11H8.75V6Zm0-2.5V5h-1.5V3.5h1.5Z", clipRule: "evenodd" }) }));
});
//# sourceMappingURL=InfoSquareFilledIcon.js.map